import { render, staticRenderFns } from "./EgressosBeneficios.vue?vue&type=template&id=23470cc4&scoped=true&lang=pug&"
import script from "./EgressosBeneficios.vue?vue&type=script&lang=js&"
export * from "./EgressosBeneficios.vue?vue&type=script&lang=js&"
import style0 from "./EgressosBeneficios.styl?vue&type=style&index=0&id=23470cc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23470cc4",
  null
  
)

export default component.exports